import React from 'react';
import { Hero } from './components/Hero';
import { SocialProofStrip } from './components/SocialProofStrip';
import { ProblemSection } from './components/ProblemSection';
import { AgitationSection } from './components/AgitationSection';
import { FailingSolutions } from './components/FailingSolutions';
import { Deliverables } from './components/Deliverables';
import { ModulesAccordion } from './components/ModulesAccordion';
import { HowItWorks } from './components/HowItWorks';
import { CaseStudies } from './components/CaseStudies';
import { ComparisonTable } from './components/ComparisonTable';
import { ForWhoSection } from './components/ForWhoSection';
import { FAQ } from './components/FAQ';
import { PricingSection } from './components/PricingSection';
import { FloatingCTA } from './components/FloatingCTA';
import { useMetaPixel } from './hooks/useMetaPixel';
export function App() {
  useMetaPixel();
  return <div className="min-h-screen w-full bg-[#faf8f5] overflow-x-hidden" data-id="element-0">
      <Hero data-id="element-1" />
      <SocialProofStrip data-id="element-2" />
      <ProblemSection data-id="element-3" />
      <AgitationSection data-id="element-4" />
      <FailingSolutions data-id="element-5" />
      <Deliverables data-id="element-6" />
      <ModulesAccordion data-id="element-7" />
      <HowItWorks data-id="element-8" />
      <CaseStudies data-id="element-9" />
      <ComparisonTable data-id="element-10" />
      <ForWhoSection data-id="element-11" />
      <FAQ data-id="element-12" />
      <PricingSection data-id="element-13" />
      <FloatingCTA data-id="element-14" />
    </div>;
}